export default function toggleResponseMessageToState(settings, disabled): void {
    const { almeResponseMessageClassName, userInputMessageClassName, callerResponse, notificationClassName} = settings.classNames;
    const messageQuery = `.${almeResponseMessageClassName}, .${userInputMessageClassName}, .${callerResponse}, .${notificationClassName}`;
    const messages = Array.from(document.querySelectorAll(messageQuery));

    messages.forEach(message => {
        (message as HTMLElement).tabIndex = disabled ? -1 : 0;
    });
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/element-disabler/src/disablers/responseMessage.ts